var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8386 12.3644C14.9355 12.4221 15.0553 12.4897 15.1908 12.5662C15.7848 12.9013 16.6828 13.4079 17.2979 14.0099C17.6826 14.3865 18.0482 14.8828 18.1146 15.4908C18.1852 16.1373 17.9033 16.744 17.3373 17.2831C16.3612 18.2131 15.1897 18.9584 13.6744 18.9584H6.32587C4.81062 18.9584 3.63912 18.2131 2.66292 17.2831C2.09707 16.744 1.81502 16.1373 1.88569 15.4908C1.95214 14.8828 2.31769 14.3865 2.70242 14.0099C3.31755 13.4079 4.21547 12.9013 4.80949 12.5662C4.94503 12.4897 5.06477 12.4221 5.1617 12.3644C8.12341 10.6009 11.8769 10.6009 14.8386 12.3644Z",
    fill: "#001E60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.62512 5.41675C5.62512 3.0005 7.58387 1.04175 10.0001 1.04175C12.4164 1.04175 14.3751 3.0005 14.3751 5.41675C14.3751 7.83299 12.4164 9.79175 10.0001 9.79175C7.58387 9.79175 5.62512 7.83299 5.62512 5.41675Z",
    fill: "#001E60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.66d75b2cdc427442527c435776ef1c4e.svg";
export { ForwardRef as ReactComponent };